const d3 = require("d3");
const { DashboardVisual } = require("@/visualisation/dashboard/dashboardVisual.js");

class EfficiencyVisual extends DashboardVisual {
    constructor(svg, currData) {
        super(svg);

        this.initChart(currData);
    }

    getBaseOpacities() {
        return [1.0, 0.4];
    }

    valToString(val) {
        return (Math.round(val * 100) / 100).toString();
    }

    getBaseColours() {
        return ["rgba(129, 151, 237, 1)", "rgba(171, 184, 248, 1)"];
    }

    initChart(currData) {
        super.initChart(this.getBaseOpacities(), this.getBaseColours(), currData.pieData);

        this.chart.append("text").attr("text-anchor", "middle").attr("dy", ".35em").attr("y", -48).text("Productivity").style("font-family", "Open Sans").style("font-size", "17px").style("font-weight", "400").style("fill", "rgba(74, 74, 74, 1)");
        this.efficiency = this.chart.append("text").attr("text-anchor", "middle").attr("dy", ".35em").attr("y", -13).text("62%").style("font-family", "Open Sans").style("font-size", "32px").style("font-weight", "600").style("fill", "rgba(74, 74, 74, 1)");
  
        // Add one word in the middle of the circle, with the open sans font
        this.output = this.chart.append("text").attr("text-anchor", "middle").attr("dy", ".35em").attr("y", 22).text("Output ").style("font-family", "Open Sans").style("font-size", "17px").style("font-weight", "400").style("fill", "rgba(74, 74, 74, 1)").append("tspan").attr("font-weight", 700).text("6.2");
        this.input = this.chart.append("text").attr("text-anchor", "middle").attr("dy", ".35em").attr("y", 45).text("Capacity    ").style("font-family", "Open Sans").style("font-size", "17px").style("font-weight", "400").style("fill", "rgba(74, 74, 74, 1)").append("tspan").attr("font-weight", 700).text("10");
  
        this.output.append("tspan").attr("font-weight", 400).text(" wh/h");
        this.input.append("tspan").attr("font-weight", 400).text(" wh/h");

        this.updateChart(currData);
    }

    updateChart(currData) {
        var capacities = currData.currCapacities;
        var totalCapacities = 0;
        for(var i in capacities) {
            totalCapacities += capacities[i];
        }


        var output = currData.flow * totalCapacities;

        this.efficiency.text(Math.round(currData.flow * 100) + "%");
        this.output.text(this.valToString(output)).append("tspan").attr("font-weight", 400).text(" wh/h");
        this.input.text(totalCapacities).append("tspan").attr("font-weight", 400).text(" wh/h");


        this.updatePie(currData.pieData)

    }
}

export { EfficiencyVisual };